var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10V11.25H6.875V13.75H7.5V15H0V13.75H0.625V11.25H0V10L3.75 8.75L7.5 10ZM2.13379 1.875H5.625V5.34766L10 9.0625V11.875H13.0713L15 13.8037V15H14.4287L12.5537 13.125H8.75V9.65332L4.375 5.9375V3.125H1.61621L0 1.50879V0H0.258789L2.13379 1.875ZM1.875 11.25V13.75H3.125V11.25H1.875ZM4.375 11.25V13.75H5.625V11.25H4.375ZM15 1.25V2.5H14.375V5H15V6.25H7.5V5H8.125V2.5H7.5V1.25L11.25 0L15 1.25ZM9.375 2.5V5H10.625V2.5H9.375ZM11.875 2.5V5H13.125V2.5H11.875Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateicon);
export default __webpack_public_path__ + "static/media/Stateicon.1b4d5f533209ab25281ba85d3201718d.svg";
export { ForwardRef as ReactComponent };